import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import { merchantApi } from "@api";
import {
    ArrowLeft,
    ArrowLongRightIcon,
    ComponentPopUpTerms,
    CorrectIcon,
    IconBack,
    ImageUploadIcon,
    NoCorrectIcon,
    SharedInput,
    StyledError,
} from "@components";
import { DAYS, MONTHS, PATH_HOME, PATH_MEMBER_TYPE, YEARS, _10MB, genderOptions } from "@configs";
import {
    IAddressData,
    IAmphur,
    IDate,
    IGroupType,
    IMemberType,
    IProvince,
    ISelect,
    ISubDistrict,
    IType,
} from "@interfaces";
import { selectApp, selectAuth, selectMerchant, setLoading } from "@redux";
import { formatMessage, useNotify } from "@utils";
import { Button, Col, Input, Radio, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
const { Option } = Select;

interface IAns {
    fullName: string;
    email: string;
    gender: string;
    dateOfBirth: string;
    address: string;
    id_card: string;
    companyName: string;
    studentID: string;
    staffID: string;
    channelStore: string;
    acceptTermsAndConditions: boolean;
}

const INIT_ANS: IAns = {
    fullName: "",
    email: "",
    gender: "",
    dateOfBirth: "",
    address: "",
    id_card: "",
    companyName: "",
    studentID: "",
    staffID: "",
    channelStore: "",
    acceptTermsAndConditions: false,
};

const INIT_ADDRESS: IAddressData = {
    address: "",
    district: "",
    province: "",
    subDistrict: "",
    postCode: "",
};
export const PageMemberTypeDetail = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    //page redux
    const { lang } = useSelector(selectApp);
    const { terms } = useSelector(selectAuth);
    const inputRef = useRef<HTMLButtonElement | null>(null);
    const { gLink, tLink } = useParams<{ gLink: string; tLink: string }>();
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { langSetting } = useSelector(selectApp);
    const { t } = useTranslation();
    const { success, error, warning } = useNotify();
    const [groupDetail, setGroupDetail] = useState<IGroupType>();
    const [typeDetail, setTypeDetail] = useState<IType>();
    const [step, setStep] = useState<number>(1);
    const [pdpa, setPdpa] = useState<boolean>(false);
    const [ans, setAns] = useState<IAns>(INIT_ANS);
    const dateCurrent = new Date(userInfo?.contact?.dateOfBirth || "");
    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);
    const [isTerm, setIsTerm] = useState<boolean>(false);
    const [disableList, setDisableList] = useState<any>({
        email: false,
        gender: false,
        date: false,
        address: false,
    });
    const [subDistrictIndex, setSubDistrictIndex] = useState<number>(0);

    const [receiptImg, setReceiptImg] = useState<any>("");
    const [imgFile, setImgFile] = useState<any>("");

    const [date, setDate] = useState<IDate>({
        day: (dateCurrent.getDate() || "").toString(),
        month: (dateCurrent.getMonth() + 1 || "").toString(),
        year: (dateCurrent.getFullYear() || "").toString(),
        error: "",
    });
    const [textDo, setTextDo] = useState<string[]>([]);
    const [textDont, setTextDont] = useState<string[]>([]);

    useEffect(() => {
        if (gLink) {
            getTypeList();
            getAllProvince();
        }
    }, [gLink]);

    useEffect(() => {
        if (userInfo) {
            let checkDisable = disableList;
            let ansUE: IAns = {
                ...INIT_ANS,
                fullName: userInfo?.fullName,
                email: userInfo?.contact?.email || "",
                gender: userInfo?.contact?.gender || "",
            };
            setAns({ ...ansUE });
            checkDisable = {
                ...disableList,
                fullName: userInfo?.fullName !== "",
                email: userInfo?.contact?.email !== "",
                gender: userInfo?.contact?.gender !== "",
                date: userInfo?.contact?.dateOfBirth !== "",
            };
            const firstFetchAddress = async () => {
                if (
                    userInfo?.contact?.address &&
                    userInfo?.contact?.address?.address !== "" &&
                    userInfo?.contact?.address?.district !== "" &&
                    userInfo?.contact?.address?.postCode !== "" &&
                    userInfo?.contact?.address?.province !== "" &&
                    userInfo?.contact?.address?.subDistrict !== ""
                ) {
                    await getAmphur(parseInt(userInfo?.contact?.address?.province));
                    await getSubDistrictByamphur(parseInt(userInfo?.contact?.address?.district));

                    // let disIndex = subDistrictList.findIndex(
                    //     (item) => item?.district_id === userInfo?.contact?.address?.subDistrict
                    // );

                    let payload: IAddressData = {
                        address: userInfo?.contact?.address?.address,
                        province: userInfo?.contact?.address?.province,
                        district: userInfo?.contact?.address?.district,
                        // subDistrict: userInfo?.contact?.address?.subDistrict,
                        subDistrict: subDistrictIndex !== -1 ? subDistrictIndex.toString() : "",
                        postCode: userInfo?.contact?.address?.postCode,
                    };
                    setAddressData(payload);

                    checkDisable.address = true;
                }
            };
            setDisableList(checkDisable);
            firstFetchAddress();
        }
    }, [userInfo]);

    const handleTerms = () => {
        setIsTerm(!isTerm);
        let ansList = ans;
        ansList.acceptTermsAndConditions = true;
        setAns({ ...ansList });
    };

    const changeAns = (e: any) => {
        let ansList = { ...ans };
        //@ts-ignore
        ansList[e.target.name] = e.target.value;
        setAns({ ...ansList });
    };
    const getTypeList = async () => {
        let res = await merchantApi.getMemberType();
        if (res.data?.result?.MemberTypeConfig?.isMemberApply) {
            let findObj = res.data?.result?.MemberTypeConfig?.memberTypeGroupName.find(
                (item: any) => item.typeGroupNameUrlPath === "/" + gLink
            );
            if (findObj !== undefined) {
                setGroupDetail(findObj);
                let findType = findObj?.typeGroupNameList.find(
                    (item: any) => item.typeNameUrlPath === "/" + tLink
                );
                setTypeDetail(findType);
                if (lang === "ENGLISH") {
                    setTextDo(findType?.evidenceInstructionsDosEng?.split("\n"));
                    setTextDont(findType?.evidenceInstructionsNotsEng?.split("\n"));
                } else {
                    setTextDo(findType?.evidenceInstructionsDosTh?.split("\n"));
                    setTextDont(findType?.evidenceInstructionsNotsTh?.split("\n"));
                }
            } else {
                warning("Don't have this group");
            }
        }
    };

    const days: ISelect[] = DAYS.map((item) => {
        return {
            id: item,
            label: item,
        };
    });
    const months: ISelect[] = MONTHS.map((item) => {
        return {
            id: item,
            label: item,
        };
    });
    const years: ISelect[] = YEARS.map((item) => {
        return {
            id: item,
            label: item,
        };
    });

    const handleChangeDay = (value: string) => {
        setDate({
            ...date,
            day: value,
            error: "",
        });
    };
    const handleChangeMonth = (value: string) => {
        setDate({
            ...date,
            month: value,
            error: "",
        });
    };
    const handleChangeYear = (value: string) => {
        setDate({
            ...date,
            year: value,
            error: "",
        });
    };

    const clickBack = () => {
        history.push(PATH_MEMBER_TYPE + "/" + gLink);
    };

    const clickRegister = () => {
        setStep(2);
    };

    const clickNext = () => {
        if (ans.acceptTermsAndConditions) {
            setStep(3);
        } else {
            warning("Please confirm PDPA");
        }
    };

    const onChangeGender = (value: string) => {
        let ansArr = { ...ans };
        ansArr.gender = value;
        setAns({ ...ansArr });
    };
    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
    };
    const getAmphur = async (pId: number) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        let newAdd = addressData;
        newAdd.province = pId.toString();
        newAdd.district = "";
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const getSubDistrictByamphur = async (aId: number) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100,
        });
        setSubDistrictList(subRes.data.result);
        setSubDistrictIndex(
            subRes.data.result.findIndex(
                (item: any) => item?.district_id === userInfo?.contact?.address?.subDistrict
            )
        );
        let newAdd = addressData;
        newAdd.province = subRes?.data?.result[0]?.province_id;
        newAdd.district = aId.toString();
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const onChangeProvince = async (value: any) => {
        setAddressData({
            ...addressData,
            province: value,
        });
        await getAmphur(value);
    };
    const onChangeAmphur = async (value: any) => {
        setAddressData({
            ...addressData,
            district: value,
        });
        await getSubDistrictByamphur(value);
    };
    const onChangeSubDistrict = (value: any) => {
        let outSub = subDistrictList[value];
        setAddressData({
            ...addressData,
            // subDistrict: outSub?.district_id,
            subDistrict: value,
            postCode: outSub?.zipcode,
        });
    };
    const setAddressText = (value: any, name: string) => {
        let newAdd = {
            ...addressData,
            [name]: value,
        };
        setAddressData({
            ...newAdd,
        });
    };
    const changeCheckBox = () => {
        let ansList = ans;
        ansList.acceptTermsAndConditions = !ans.acceptTermsAndConditions;
        setAns({ ...ansList });
    };
    const handleChangeTerm = (e: boolean) => {
        setIsTerm(!isTerm);
    };

    const clickCamera = async () => {
        await null;
        await setStep(4);

        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    const changeImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            setReceiptImg("");
            return;
        } else {
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setImgFile(e.target.files[0]);
            setReceiptImg(objectUrl);
        }
    };

    const uploadImage = async (formData: FormData) => {
        try {
            const res = await merchantApi.uploadImage(formData);
            return res.data.publicUrl;
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleConfirm = async () => {
        await null;
        try {
            dispatch(setLoading(true));
            if (receiptImg !== "") {
                if (imgFile.size >= _10MB) {
                    error(t("validation.image.max_size"));
                    dispatch(setLoading(false));
                } else {
                    const formData = new FormData();
                    formData.append("file", imgFile);

                    let imgUrl = await uploadImage(formData);

                    // let payload: IUploadReceipt = {
                    //     merchantId: userInfo?.merchantId || "",
                    //     userId: userInfo?.contact?.userId || "",
                    //     userName: userInfo?.username || "",
                    //     userTel: userInfo?.phoneNumber || "",
                    //     imageUrl: imgUrl,
                    // };
                    const dateForm =
                        date.month && date.day && date.year
                            ? new Date(date.month + "/" + date.day + "/" + date.year)
                            : null;
                    let outSubdisIndex = 0;
                    if (addressData?.subDistrict !== "") {
                        outSubdisIndex = parseInt(addressData.subDistrict);
                    }
                    let payload: IMemberType = {
                        memberTypeNameId: typeDetail?._id || "",
                        // memberTypeGroupNameId:
                        userId: userInfo?._id || "",
                        studentId: ans?.studentID || "",
                        id_card: ans?.id_card,
                        imageUrl: imgUrl,
                        fullName: userInfo?.fullName || "",
                        acceptTermsAndConditions: ans.acceptTermsAndConditions,
                        memberTypeGroupNameId: groupDetail?._id || "",
                        ...(dateForm && { dateOfBirth: dateForm }),
                        ...(ans.email && { email: ans.email }),
                        ...(ans.gender && { gender: ans.gender }),
                        address: {
                            ...addressData,
                            subDistrict:
                                addressData.subDistrict !== ""
                                    ? subDistrictList[outSubdisIndex]?.district_id
                                    : "",
                        },
                        ...(ans.companyName && { companyName: ans.companyName }),
                        ...(ans.staffID && { staffId: ans.staffID }),
                        ...(ans.channelStore && { channelStore: ans.channelStore }),
                        userTel: userInfo?.contact?.phoneNumber || "",
                        merchantId: userInfo?.merchantId,
                    };
                    await merchantApi.postMemberType(payload);
                    success(t("page.upload_receipt.success"));
                    // history.push(PATH_HOME);
                    setStep(5);
                }
            } else {
                error(t("page.upload_receipt.empty_error"));
            }
        } catch (err: any) {
            // const data = err.response.data;
            // const mess = Array.isArray(data.errors) ? data.errors[0] : data.message;
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    return (
        <>
            {step === 1 && (
                <StyledTypePage themeColor={themes?.themeColor!}>
                    <div className="layout-back" onClick={clickBack}>
                        <IconBack />
                    </div>
                    <img src={typeDetail?.typeNameCoverImage} className="top-img" />
                    <div className="bene-section">
                        <Button onClick={clickRegister} className="regis-btn">
                            {t("page.mem_type.regis_btn")}
                        </Button>
                        <p className="bene-for">
                            {t("page.mem_type.bene_for")} {typeDetail?.typeName}
                        </p>
                        <div className="bene-list">
                            {typeDetail?.typeNameBenefit?.map((bItem: any, bIndex: number) => {
                                return (
                                    <div className="layout-detail-card" key={bIndex}>
                                        <div className="topic-member-detail">
                                            {langSetting?.language === "ENGlIST"
                                                ? bItem?.typeNameBenefitTitle
                                                : bItem?.typeNameBenefitTitleTh}
                                        </div>
                                        <div className="desc-member-detail">
                                            {langSetting?.language === "ENGlIST" ? (
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: bItem?.typeNameBenefitDescrip,
                                                    }}
                                                ></p>
                                            ) : (
                                                <p
                                                    dangerouslySetInnerHTML={{
                                                        __html: bItem?.typeNameBenefitDescripTh,
                                                    }}
                                                ></p>
                                            )}
                                        </div>
                                        <div className="img-member-detail">
                                            <a href="">
                                                <img
                                                    src={bItem?.typeNameBenefitIcon}
                                                    className="bene-icon"
                                                />
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </StyledTypePage>
            )}
            {step === 2 && (
                <StyledReceiptPage themeColor={themes?.themeColor!}>
                    <div className="step-logo">
                        {/* <div className="step">
                            <p>1</p>
                            <div>&nbsp;</div>
                            <p>2</p>
                        </div> */}
                        <div className="logo">
                            <img src={merchant?.themes?.logoSmallUrl} />
                        </div>
                    </div>

                    <h1>
                        {/* {t("page.mem_type.create_title")} */}
                        Create {typeDetail?.typeName} Member
                    </h1>
                    <p className="input-title ">{t("page.name")}</p>
                    <Input disabled value={userInfo?.fullName} />
                    {typeDetail?.typeNameSignForm?.map((fItem: any, fIndex: number) => {
                        if (fItem?.name === "dateOfBirth" && fItem?.isActive) {
                            return (
                                <div key={fIndex}>
                                    <p className="input-title ">{t("page.birth_date")}</p>
                                    <div className="day">
                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <Select
                                                    onChange={handleChangeDay}
                                                    value={date.day === "" ? undefined : date.day}
                                                    placeholder={"day"}
                                                    className={
                                                        "date-select " +
                                                        (disableList.address && "disable-select")
                                                    }
                                                    disabled={disableList.date}
                                                >
                                                    {days.map((item) => {
                                                        return (
                                                            <Option value={item.id} key={item.id}>
                                                                {item.label}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Col>
                                            <Col span={8}>
                                                <Select
                                                    onChange={handleChangeMonth}
                                                    value={
                                                        date.month === "" ? undefined : date.month
                                                    }
                                                    placeholder={"month"}
                                                    className={
                                                        "date-select " +
                                                        (disableList.address && "disable-select")
                                                    }
                                                    disabled={disableList.date}
                                                >
                                                    {months.map((item) => {
                                                        return (
                                                            <Option value={item.id} key={item.id}>
                                                                {item.label}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Col>
                                            <Col span={8}>
                                                <Select
                                                    onChange={handleChangeYear}
                                                    value={date.year === "" ? undefined : date.year}
                                                    placeholder={"year"}
                                                    className={
                                                        "date-select " +
                                                        (disableList.address && "disable-select")
                                                    }
                                                    disabled={disableList.date}
                                                >
                                                    {years.map((item) => {
                                                        return (
                                                            <Option value={item.id} key={item.id}>
                                                                {item.label}
                                                            </Option>
                                                        );
                                                    })}
                                                </Select>
                                            </Col>
                                        </Row>
                                        {date.error && (
                                            <StyledError visible={true}>
                                                {t("validation.is_required")}{" "}
                                            </StyledError>
                                        )}
                                    </div>
                                </div>
                            );
                        } else if (fItem?.name === "gender" && fItem?.isActive) {
                            return (
                                <div className="gender" key={fIndex}>
                                    <p className="input-title ">{t("page.gender")}</p>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Radio.Group
                                                value={ans.gender}
                                                onChange={(e) => onChangeGender(e.target.value)}
                                                className={
                                                    "gender-radio " +
                                                    (disableList.gender && "disable-radio")
                                                }
                                                disabled={disableList.gender}
                                            >
                                                <Row gutter={16}>
                                                    {genderOptions.map((option) => (
                                                        <Col key={option.id} span={24}>
                                                            <Radio value={option.id}>
                                                                {option.label}
                                                            </Radio>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Radio.Group>
                                        </Col>
                                    </Row>
                                </div>
                            );
                        } else if (
                            fItem?.name === "address" &&
                            !merchant?.signUpSettings?.staticQuestion?.address?.isRedeem
                        ) {
                            return (
                                <StyledSurvey mainColor={themes?.themeColor!} key={fIndex}>
                                    <div>
                                        <p className="input-title ">{t("page.address")}</p>
                                        <SharedInput
                                            name="freeTextAnswer"
                                            value={addressData?.address}
                                            onChange={(e: React.ChangeEvent<HTMLFormElement>) =>
                                                setAddressText(e.target.value, "address")
                                            }
                                            styleParent={{ height: "48px" }}
                                            style={{
                                                backgroundColor: "white",
                                                border: "1px solid gray",
                                            }}
                                            className={
                                                "" + (disableList.address && "disable-select")
                                            }
                                            disable={disableList.address}
                                        />
                                        <div>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <p className="input-title ">
                                                        {t("page.province")}
                                                    </p>
                                                </Col>
                                                <Col span={12}>
                                                    <p className="input-title ">
                                                        {t("page.county")}
                                                    </p>
                                                </Col>
                                                <Col span={12}>
                                                    <Select
                                                        onChange={onChangeProvince}
                                                        value={
                                                            addressData?.province === ""
                                                                ? undefined
                                                                : addressData.province
                                                        }
                                                        placeholder={t("page.province")}
                                                        className={
                                                            "address-select " +
                                                            (disableList.address &&
                                                                "disable-select")
                                                        }
                                                        disabled={disableList.address}
                                                    >
                                                        {provinceList?.length > 0 &&
                                                            provinceList?.map((pItem, pIndex) => {
                                                                return (
                                                                    <Option
                                                                        value={pItem?.province_id}
                                                                        key={pIndex}
                                                                    >
                                                                        {pItem.province_name_tha}
                                                                    </Option>
                                                                );
                                                            })}
                                                    </Select>
                                                </Col>
                                                <Col span={12}>
                                                    <Select
                                                        onChange={onChangeAmphur}
                                                        value={
                                                            addressData.district === ""
                                                                ? undefined
                                                                : addressData.district
                                                        }
                                                        placeholder={t("page.county")}
                                                        className={
                                                            "address-select " +
                                                            (disableList.address &&
                                                                "disable-select")
                                                        }
                                                        disabled={disableList.address}
                                                    >
                                                        {amphurList?.length > 0 &&
                                                            amphurList?.map((aItem, aIndex) => {
                                                                return (
                                                                    <Option
                                                                        value={aItem?.amphur_id}
                                                                        key={aIndex}
                                                                    >
                                                                        {aItem?.amphur_name_tha}
                                                                    </Option>
                                                                );
                                                            })}
                                                    </Select>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <p className="input-title ">
                                                        {t("page.district")}
                                                    </p>
                                                </Col>
                                                <Col span={12}>
                                                    <p className="input-title ">
                                                        {t("page.zipcode")}
                                                    </p>
                                                </Col>
                                                <Col span={12}>
                                                    <Select
                                                        onChange={onChangeSubDistrict}
                                                        value={
                                                            addressData.subDistrict === ""
                                                                ? undefined
                                                                : parseInt(addressData.subDistrict)
                                                        }
                                                        placeholder={t("page.district")}
                                                        disabled={disableList.address}
                                                        className={
                                                            "address-select " +
                                                            (disableList.address &&
                                                                "disable-select")
                                                        }
                                                    >
                                                        {subDistrictList?.length > 0 &&
                                                            subDistrictList?.map(
                                                                (sItem, sIndex) => {
                                                                    return (
                                                                        <Option
                                                                            value={sIndex}
                                                                            key={sIndex}
                                                                        >
                                                                            {
                                                                                sItem?.district_name_tha
                                                                            }
                                                                        </Option>
                                                                    );
                                                                }
                                                            )}
                                                    </Select>
                                                </Col>
                                                <Col span={12}>
                                                    <SharedInput
                                                        name="freeTextAnswer"
                                                        value={addressData?.postCode}
                                                        onChange={(
                                                            e: React.ChangeEvent<HTMLFormElement>
                                                        ) =>
                                                            setAddressText(
                                                                e.target.value,
                                                                "postCode"
                                                            )
                                                        }
                                                        styleParent={{ height: "48px" }}
                                                        style={{
                                                            backgroundColor: "white",
                                                            border: "1px solid gray",
                                                        }}
                                                        disable={disableList.address}
                                                        className={
                                                            "" +
                                                            (disableList.address &&
                                                                "disable-select")
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </StyledSurvey>
                            );
                        } else {
                            if (fItem?.isActive) {
                                return (
                                    <div key={fIndex}>
                                        <p className="input-title ">{fItem?.name}</p>
                                        <Input
                                            //@ts-ignore
                                            value={ans[fItem?.name]}
                                            name={fItem?.name}
                                            onChange={changeAns}
                                            disabled={disableList?.[fItem?.name] || false}
                                        />
                                    </div>
                                );
                            }
                        }
                    })}
                    {isTerm && (
                        <ComponentPopUpTerms
                            data={terms}
                            handleConfirm={handleTerms}
                            showTerm={isTerm}
                        />
                    )}
                    <div className="radio-section">
                        <Radio checked={ans.acceptTermsAndConditions} onClick={changeCheckBox} />
                        <p className="radio-text">
                            ฉันยอมรับ
                            <span onClick={() => handleChangeTerm(true)}>
                                เงื่อนไข และข้อตกลงการใช้บริการ
                            </span>
                            ของทางบริษัท
                        </p>
                    </div>

                    <Button className="next-btn" onClick={clickNext}>
                        Next <ArrowLongRightIcon />
                    </Button>
                </StyledReceiptPage>
            )}
            {step === 3 && (
                <StyledExamplePage themeColor={themes?.themeColor!}>
                    <div className="title-section">
                        <ArrowLeft />
                        <h1>
                            {t("page.mem_type.verify_title")}
                            {/* Selfie indetity <br />
                            verifycation with {typeDetail?.typeName} <br />
                            card */}
                        </h1>
                    </div>
                    <div className="verify-detail">
                        <img
                            src={
                                typeDetail?.evidenceImage
                                    ? typeDetail?.evidenceImage
                                    : "/images/img-student-profile.svg"
                            }
                            className="verify-img"
                        />
                        <br />
                        <br />
                        {textDo?.length > 0 ? (
                            textDo.map((tItem, tIndex) => {
                                if (tItem) {
                                    return (
                                        <p className="verify-desc" key={tIndex}>
                                            <CorrectIcon /> {tItem}
                                        </p>
                                    );
                                }
                            })
                        ) : (
                            <div>
                                <p className="verify-desc">
                                    <CorrectIcon /> ถ่ายรูปหน้าตรงชัดเจนคู่บัตรนักเรียน
                                </p>
                                <p className="verify-desc">
                                    <CorrectIcon /> รูปต้องชัดเจนให้เห็นตัวอักษรบนบัตร
                                </p>
                            </div>
                        )}

                        <br />
                        {textDont?.length > 0 ? (
                            textDont.map((tItem, tIndex) => {
                                if (tItem) {
                                    return (
                                        <p className="verify-desc" key={tIndex}>
                                            <NoCorrectIcon /> {tItem}
                                        </p>
                                    );
                                }
                            })
                        ) : (
                            <div>
                                <p className="verify-desc">
                                    <NoCorrectIcon /> ต้องไม่บังใบหน้าส่วนใดส่วนหนึ่ง
                                </p>
                                <p className="verify-desc">
                                    <NoCorrectIcon /> ไม่ใส่ที่คาดผลหรือเรื่องประดับ
                                </p>
                            </div>
                        )}
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <Button onClick={clickCamera} className="next-btn">
                            Selfie Verify {typeDetail?.typeName} &nbsp; <ArrowLongRightIcon />
                        </Button>
                    </div>
                </StyledExamplePage>
            )}
            {step === 4 && (
                <StyledStep4 themeColor={themes?.themeColor!}>
                    <div className="title-section">
                        <ArrowLeft />
                        <h1>
                            {t("page.mem_type.verify_title")}
                            {/* Selfie indetity <br />
                            verifycation with {typeDetail?.typeName} <br />
                            card */}
                        </h1>
                    </div>
                    <input
                        //@ts-ignore
                        ref={inputRef}
                        type="file"
                        hidden
                        id="uploadImage"
                        onChange={changeImg}
                        accept="image/png, image/jpeg, image/jpg"
                    />
                    <div className="box-image">
                        {receiptImg === "" ? (
                            <div className="dont-have-img">
                                <label className="camera-text" htmlFor="uploadImage">
                                    <ImageUploadIcon color={themes?.themeColor!} />
                                    <p className="input-title ">
                                        + {t("page.upload_receipt.upload_text")}
                                        {/* <span className="color-span">{t("page.upload_receipt.receipt")}</span> */}
                                    </p>
                                </label>
                            </div>
                        ) : (
                            <div className="have-img">
                                <label className="camera-text" htmlFor="uploadImage">
                                    <img src={receiptImg} />
                                </label>
                            </div>
                        )}
                    </div>
                    {/* <Camera /> */}
                    <Button onClick={handleConfirm} className="confirm-btn">
                        {t("page.confirm")}
                    </Button>
                </StyledStep4>
            )}
            {step === 5 && (
                <StyleStep5 themeColor={themes?.themeColor!}>
                    <img src="/images/apply_success.png" />
                    <p className="input-title ">
                        {/* Register {typeDetail?.typeName}
                        <br />
                        Success! */}
                        {t("page.mem_type.upload_suscess")}
                    </p>
                    <p className="wait-text">{t("page.mem_type.please_wait")}</p>
                    <Button onClick={() => history.push(PATH_HOME)}>{t("page.done")}</Button>
                </StyleStep5>
            )}
        </>
    );
};

const StyledTypePage = styled.div<{ themeColor: string }>`
    height: 100vh;
    position: relative;
    background-color: #fff;
    .layout-back {
        position: absolute;
        left: 16px;
        top: 16px;
    }
    .top-img {
        width: 100%;
        height: auto;
        object-fit: cover;
    }
    .bene-section {
        background-color: #fff;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        padding: 24px 16px 16px 16px;
        overflow: hidden;
        margin-top: -15px;
        z-index: 1;
        position: relative;
        .regis-btn {
            width: 100%;
            height: 48px;
            color: #fff;
            border-radius: 50px;
            background-color: ${(p) => p.themeColor};
            margin-bottom: 24px;
        }
        .bene-for {
            color: ${(p) => p.themeColor};
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
            background-image: url(../../images/ic-benefit.svg);
            padding-left: 25px;
            background-repeat: no-repeat;
            background-position: left center;
            span {
                color: #85b1e0;
                font-weight: 600;
            }
        }
        .bene-list {
            .layout-detail-card {
                position: relative;
                margin-bottom: 16px;
                padding: 30px 16px;
                border-radius: 14px;
                padding-right: 120px;
                background-color: #f8f4ec;
                min-height: 103px;
                .img-member-detail {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    a {
                        img {
                            max-width: 80px;
                            width: 100%;
                        }
                    }
                }
                .topic-member-detail {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 500;
                    color: #000;
                    margin-bottom: 10px;
                }
                .desc-member-detail {
                    font-size: 11px;
                    line-height: 13px;
                    color: #525257;
                }
            }
            .bene-item {
                padding: 15px;
                border-radius: 15px;
                background-color: ${(p) => p.themeColor}10;
                display: grid;
                grid-template-columns: 80% 20%;
                .bene-icon {
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                }
            }
        }
    }
`;

const StyledReceiptPage = styled.div<{ themeColor: string }>`
    height: 100vh;
    padding: 20px;
    .step-logo {
        display: flex;
        justify-content: center;
        padding-bottom: 20px;
        .logo {
            img {
                max-width: 60px;
                max-height: 60px;
            }
        }
    }
    h1 {
        font-size: 24px;
        font-weight: 500;
        color: ${(p) => p.themeColor};
        padding-bottom: 25px;
        border-bottom: 1px solid ${(p) => p.themeColor}70;
        text-align: center;
    }
    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        padding-top: 12px;
    }
    .input-title {
        margin-bottom: 5px;
        margin-top: 15px;
        color: ${(p) => p.themeColor};
    }
    .input-receipt {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .input-receipt:focus {
        outline: none;
        box-shadow: none;
    }

    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
    .next-btn {
        width: 100%;
        height: 48px;
        color: white;
        background-color: ${(p) => p.themeColor};
        border-radius: 500px;
        margin-top: 40px;
    }
    .field-input {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .field-input:focus {
        outline: none;
        box-shadow: none;
    }
    p {
        margin-bottom: 5px;
        margin-top: 15px;
        color: ${(p) => p.themeColor};
    }
    .radio-section {
        margin-top: 30px;
        display: flex;
        .radio-text {
            color: #9daaae;
            margin: 0;
            span {
                font-weight: 500;
                color: ${(p) => p.themeColor};
                padding: 0 10px;
                cursor: pointer;
            }
        }
    }
    .ant-select-selection {
        box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        border-radius: 6px;
        border: 1px solid lightgray;
    }
    .date-select {
        width: 100%;
        height: 48px;
    }
    .gender-select {
        width: 100%;
        height: 48px;
    }
    .address-select {
        width: 100%;
        height: 48px;
    }
    .next-btn {
        width: 100%;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        height: 48px;
        border-radius: 50px;
    }
    .disable-select {
        background-color: #f6f6f6 !important;
        .ant-select-selection {
            background-color: #f6f6f6 !important;
        }
    }
    .gender {
        .ant-radio-checked {
            .ant-radio-inner {
                border-color: ${(p) => p.themeColor};
                background-color: ${(p) => p.themeColor};
            }
        }
    }
`;

const StyledSurvey = styled.div<{ mainColor: string }>`
    /* padding: 20px ; */
    .ant-select-selection {
        box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 6px;
        background-color: #fff;
        border: 1px solid #dadada !important;
        cursor: default;
        width: 100%;
    }
    .intl-tel-input input {
        border-radius: 6px;
    }
    .term-field {
        display: flex;
        justify-content: center;
    }
    .btn-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        .btn {
            width: 100%;
            height: 55px;
            border-radius: 500px;
            font-size: 16px;
        }
        .back {
            color: #f22f46;
            background-color: #fff;
            border: 1px solid #f22f46;
        }
        .save {
            //
            background-color: #f22f46;
            color: white;
        }
    }
    /* .input-title {
        margin: 12px 0 8px 0;
        color: #919191;
        font-size: 16px;
        font-weight: 500;
    } */
    /* .multiple-title {
        margin-bottom: 0px;
        line-height: 16px;
    } */
    .ant-select-selection--multiple {
        .ant-select-arrow {
            margin-top: 0px;
        }
    }
`;

const StyledExamplePage = styled.div<{ themeColor: string }>`
    padding: 20px;
    .title-section {
        display: flex;
        justify-content: space-between;
        h1 {
            font-size: 25px;
            font-weight: 500;
            text-align: right;
            color: ${(p) => p.themeColor};
        }
    }
    .verify-detail {
        text-align: center;
        img {
            width: 100%;
            border-radius: 32px;
        }
    }
    .next-btn {
        width: 100%;
        height: 48px;
        border-radius: 500px;
        background-color: ${(p) => p.themeColor};
        color: white;
    }
    .verify-desc {
        margin: 15px;
        color: ${(p) => p.themeColor};
        font-weight: 500;
        font-size: 16px;
    }
`;

const StyledStep4 = styled.div<{ themeColor: string }>`
    padding: 20px;
    .title-section {
        display: flex;
        justify-content: space-between;
        h1 {
            font-size: 25px;
            font-weight: 500;
            text-align: right;
            color: ${(p) => p.themeColor};
        }
    }
    .box-image {
        margin: 30px 30px;
        margin-top: 10vh;
        background-color: ${(p) => p.themeColor}20;
        border-radius: 20px;
        text-align: center;
        border: 1px dashed ${(p) => p.themeColor};
        height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
        .dont-have-img {
            margin: 40px 20px;
            cursor: pointer;
        }
        svg {
            margin-bottom: 10px;
        }
        .have-img {
            margin: 8px;
            position: relative;
            width: 100%;
            img {
                max-width: 95%;
                height: 330px;
                object-fit: cover;
            }
            &:after {
                content: "";
                position: absolute;
                width: calc(100% + 18px);
                height: calc(100% + 20px);
                border: 6px solid #5b835d;
                border-radius: 16px;
                left: -9px;
                top: -10px;
            }
            &:before {
                content: "";
                position: absolute;
                top: -50px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 2;
                width: 85px;
                height: 85px;
                border-radius: 100%;
                border: 6px solid #fff;
                background-image: url(../../images/img-check.svg);
                background-repeat: no-repeat;
                background-position: center;
            }
        }
        .color-span {
            color: ${(p) => p.themeColor};
        }
    }
    .confirm-btn {
        width: 100%;
        height: 48px;
        border-radius: 500px;
        background-color: ${(p) => p.themeColor};
        color: white;
    }
`;

const StyleStep5 = styled.div<{ themeColor: string }>`
    text-align: center;
    img {
        margin-top: 25vh;
    }
    p {
        margin-top: 20px;
        color: ${(p) => p.themeColor};
        font-size: 30px;
    }
    .wait-text {
        font-size: 22px;
        margin-top: 5px;
    }
    button {
        width: 50%;
        height: 48px;
        margin-top: 20px;
        border-radius: 500px;
        background-color: ${(p) => p.themeColor};
        color: white;
    }
`;
